import type {
  ListingAccount,
  ListingFilters,
  Pagination,
  TimeFilter,
} from "./types";

export const getPage = (
  accounts: ListingAccount[],
  pagination?: Pagination
): ListingAccount[] => {
  let page = 1;
  let perPage = 20;
  if (pagination !== undefined) {
    page = pagination.page;
    perPage = pagination.perPage;
  }
  const paginated = accounts.slice((page - 1) * perPage, page * perPage);
  return paginated;
};

export const containsTags = (
  account: ListingAccount,
  filterTags: string[]
): boolean => {
  return account.tags.some((tag) =>
    filterTags.some((filterTag) => filterTag === tag)
  );
};

export const isWithinRange = (
  account: ListingAccount,
  field: "createdAt",
  range: TimeFilter
): boolean => {
  const value = account[field];
  let isWithinRange = true;
  if (range.start !== undefined) {
    isWithinRange = isWithinRange && range.start <= value;
  }
  if (range.end !== undefined) {
    isWithinRange = isWithinRange && value < range.end;
  }
  return isWithinRange;
};

export const applyFilter = (
  accounts: ListingAccount[],
  filters: ListingFilters
): ListingAccount[] => {
  return accounts
    .filter((account) => {
      return filters.tags !== undefined
        ? containsTags(account, filters.tags)
        : true;
    })
    .filter((account) => {
      return filters.createdAt !== undefined
        ? isWithinRange(account, "createdAt", filters.createdAt)
        : true;
    });
};
